import { render } from "./ExportYotpo.vue?vue&type=template&id=4f1b92f2&scoped=true"
import script from "./ExportYotpo.vue?vue&type=script&lang=js"
export * from "./ExportYotpo.vue?vue&type=script&lang=js"

import "./ExportYotpo.vue?vue&type=style&index=0&id=4f1b92f2&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1b92f2"]])

export default __exports__